import { computed } from 'vue';

import { ProductPriceDTO } from '@common/contracts/server/modules/product/presentation/api/dto';

export const useDiscount = (price?: Partial<ProductPriceDTO>) => {
  const discountRate = computed(() => {
    const parsedDiscountRate = parseInt(`${price?.discountRate}`);

    return isNaN(parsedDiscountRate) ? 0 : parsedDiscountRate;
  });

  const isDiscountRateVisible = computed<boolean>(() => discountRate.value > 0);

  return {
    discountRate,
    isDiscountRateVisible,
  };
};
